'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { StationData } from "@/lib/types/api/stations-data";
import { useHasMounted } from '@/lib/hooks';
import { useIdentity } from '@/lib/hooks/useIdentity';

// constants
import { DONATE_FALLBACK_URL, PASSPORT_DONATE_FEATURE_CATEGORY } from '@/lib/constants';

// components
import DonateLinkButton from '@/components/Button/DonateLinkButton';

// styles
import styles from './PassportDonateButton.module.scss'

interface PassportDonateButtonProps {
  defaultCtaText?: string;
  depUserIsLocalizedPassport?: boolean;
  hideHeartIcon?: boolean;
  gtmEventDataObjectLocation?: string;
  hideForLocalizedPassport?: boolean;
  passportUserCtaText?: string;
  stationData?: StationData;
  className?: string;
}

const PassportDonateButton = (props: PassportDonateButtonProps) => {
  const {
    defaultCtaText = `Donate & Start Watching`,
    depUserIsLocalizedPassport,
    gtmEventDataObjectLocation,
    hideForLocalizedPassport = false,
    passportUserCtaText = "Make Another Donation",
    stationData,
    className,
    hideHeartIcon = false
  } = props;

  const hasMounted = useHasMounted();
  const { cachedIdentity } = useIdentity();

  if (!hasMounted || !stationData) {
    return null;
  }

  const isLocalizedPassportMember = cachedIdentity?.isPassportMemberOf(stationData) ?? false;

  const stationAttributes = stationData.attributes;
  const donateUrl = stationAttributes.passport_url ? stationAttributes.passport_url : DONATE_FALLBACK_URL;

  const showPassportCta = depUserIsLocalizedPassport ?? isLocalizedPassportMember;

  const classNames = styles.passport_donate_button + (className ? ` ${className}` : '');

  if (hideForLocalizedPassport && showPassportCta) {
    return null;
  }

  return (
    showPassportCta ?
      <DonateLinkButton
        style="white"
        href={donateUrl}
        target="_blank"
        iconBefore={hideHeartIcon ? undefined : 'heart'}
        className={classNames}
        gtmEventData={{
          feature_category: PASSPORT_DONATE_FEATURE_CATEGORY,
          feature_name: "passport donate link (localized passport member)",
          object_text: passportUserCtaText,
          object_url: donateUrl,
          object_location: gtmEventDataObjectLocation
        }}
      >
        {passportUserCtaText}
      </DonateLinkButton> :
      <DonateLinkButton
        style="light_blue"
        href={donateUrl}
        target="_blank"
        className={classNames}
        gtmEventData={{
          feature_category: PASSPORT_DONATE_FEATURE_CATEGORY,
          feature_name: "passport donate link (signed out, non-localized or non-passport member)",
          object_text: defaultCtaText,
          object_url: donateUrl,
          object_location: gtmEventDataObjectLocation
        }}
      >
        {defaultCtaText}
      </DonateLinkButton>
  )
}


export default PassportDonateButton;
